import React, { useContext } from 'react';

import { theme } from 'config/theme';
import { CanvasUnitContext, selectionPad } from '../canvasScale';

const MAGENTA = theme.palette.primary.main;
const HANDLE_SIZE = 6;

export default function SelectionHighlight({ figW, figH }: { figW: number; figH: number }) {
    const unit = useContext(CanvasUnitContext);
    const pad = selectionPad(figW, figH, unit);
    const handleSize = HANDLE_SIZE * unit;
    const boxX = -figW / 2 - pad;
    const boxY = -figH / 2 - pad;
    const boxW = figW + pad * 2;
    const boxH = figH + pad * 2;

    const handles: [number, number][] = [
        [boxX, boxY],
        [boxX + boxW / 2, boxY],
        [boxX + boxW, boxY],
        [boxX, boxY + boxH / 2],
        [boxX + boxW, boxY + boxH / 2],
        [boxX, boxY + boxH],
        [boxX + boxW / 2, boxY + boxH],
        [boxX + boxW, boxY + boxH],
    ];

    return (
        <g pointerEvents="none">
            <rect
                x={boxX}
                y={boxY}
                width={boxW}
                height={boxH}
                fill="none"
                stroke={MAGENTA}
                strokeWidth={1.5 * unit}
                strokeDasharray={`${5 * unit} ${3 * unit}`}
                rx={3 * unit}
            />
            {handles.map(([hx, hy], idx) => (
                <rect
                    key={idx}
                    x={hx - handleSize / 2}
                    y={hy - handleSize / 2}
                    width={handleSize}
                    height={handleSize}
                    fill={MAGENTA}
                    stroke="white"
                    strokeWidth={unit}
                />
            ))}
        </g>
    );
}
